import { render, staticRenderFns } from "./commonPhraseDialog.vue?vue&type=template&id=687b1afe&scoped=true"
import script from "./commonPhraseDialog.vue?vue&type=script&lang=js"
export * from "./commonPhraseDialog.vue?vue&type=script&lang=js"
import style0 from "./commonPhraseDialog.vue?vue&type=style&index=0&id=687b1afe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b1afe",
  null
  
)

export default component.exports